import { render, staticRenderFns } from "./WkFormItems.vue?vue&type=template&id=1e3e4bd1&scoped=true&"
import script from "./WkFormItems.vue?vue&type=script&lang=js&"
export * from "./WkFormItems.vue?vue&type=script&lang=js&"
import style0 from "./WkFormItems.vue?vue&type=style&index=0&id=1e3e4bd1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3e4bd1",
  null
  
)

component.options.__file = "WkFormItems.vue"
export default component.exports